module.exports = __webpack_public_path__ + "static/img/dummy1.e7b96c7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dummy1.jpg
// module id = IYne
// module chunks = 1